<template>
  <div class="bg-efintelwhite-50 mx-auto px-3 sm:px-6 lg:px-8 p-6">
    <div v-if="loading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-2 sm:gap-3">
      <div v-for="i in 5" :key="i" class="bg-white rounded-xl p-3 sm:p-4 border border-efintelwhite-55 h-32 sm:h-36 animate-pulse">
        <div class="flex items-center justify-between">
          <div>
            <div class="h-3 bg-gray-200 rounded w-20 mb-2"></div>
            <div class="h-6 bg-gray-200 rounded w-12"></div>
          </div>
          <div class="w-6 h-6 bg-gray-200 rounded-full"></div>
        </div>
      </div>
    </div>

    <div v-else-if="error" class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
        </svg>
        Error cargando métricas: {{ error }}
      </div>
    </div>

    <div v-else-if="!loading && !error" ref="swapyContainer" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-2 sm:gap-3">

      <div :data-swapy-slot="!swapyFailed ? 'a' : null" class="col-span-1 sm:col-span-2">
        <div :data-swapy-item="!swapyFailed ? 'a' : null" class="rounded-xl p-3 sm:p-4 border h-32 sm:h-36 flex flex-col justify-between transition-colors duration-300" :class="itemEnSlotPrincipal === 'a' ? 'border-blue-400 bg-blue-50/30 shadow-md' : 'border-efintelwhite-55 bg-white'">
          <div class="grid grid-cols-2 gap-2 h-full">
            <div class="flex items-center gap-1 min-w-0">
              <div class="flex-1 min-w-0">
                <p class="text-xs font-medium text-gray-600 mb-0.5 truncate">Total Dispositivos</p>
                <p class="font-bold text-gray-900 transition-all duration-300" :class="itemEnSlotPrincipal === 'a' ? 'text-xl sm:text-2xl lg:text-3xl' : 'text-sm sm:text-base lg:text-lg'">
                  {{ metricas.totalDispositivos }}
                </p>
              </div>
              <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-2.5 h-2.5 sm:w-3 sm:h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"></path>
                </svg>
              </div>
            </div>
            <div class="flex items-center gap-1 min-w-0">
              <div class="flex-1 min-w-0">
                <p class="text-xs font-medium text-green-600 mb-0.5 truncate">Operativos</p>
                <p class="text-sm sm:text-base lg:text-lg font-bold text-green-600">{{ metricas.operativos }}</p>
              </div>
              <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-2.5 h-2.5 sm:w-3 sm:h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
            </div>
            <div class="flex items-center gap-1 min-w-0">
              <div class="flex-1 min-w-0">
                <p class="text-xs font-medium text-red-600 mb-0.5 truncate">Alertas Activas</p>
                <p class="text-sm sm:text-base font-bold text-red-600">{{ metricas.alertasActivas }}</p>
              </div>
              <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-2.5 h-2.5 sm:w-3 sm:h-3 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
              </div>
            </div>
            <div class="flex items-center gap-1 min-w-0">
              <div class="flex-1 min-w-0">
                <p class="text-xs font-medium text-gray-600 mb-0.5 truncate">Fuera de Servicio</p>
                <p class="text-sm sm:text-base font-bold text-gray-500">{{ metricas.fueraServicio }}</p>
              </div>
              <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-2.5 h-2.5 sm:w-3 sm:h-3 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 5v14m7-7H5"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :data-swapy-slot="!swapyFailed ? 'b' : null">
        <div :data-swapy-item="!swapyFailed ? 'b' : null" @click="abrirModalOperacion" class="rounded-xl p-3 sm:p-4 border h-32 sm:h-36 flex flex-col justify-center cursor-pointer transition-colors duration-300" :class="itemEnSlotPrincipal === 'b' ? 'border-blue-400 bg-blue-50/30 shadow-md' : 'border-efintelwhite-55 bg-white hover:shadow-md'">
          <div class="text-center">
            <p class="text-xs font-medium text-gray-600 mb-1">Distribución Operativa</p>

            <div class="relative w-12 h-12 mx-auto mb-2">
              <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="transparent" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op100 > 0" class="text-green-500" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op100} 100`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op80 > 0" class="text-lime-500" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op80} 100`" :stroke-dashoffset="`-${metricas.porcentajes.op100}`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op60 > 0" class="text-yellow-400" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op60} 100`" :stroke-dashoffset="`-${metricas.porcentajes.op100 + metricas.porcentajes.op80}`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op40 > 0" class="text-orange-400" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op40} 100`" :stroke-dashoffset="`-${metricas.porcentajes.op100 + metricas.porcentajes.op80 + metricas.porcentajes.op60}`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op20 > 0" class="text-red-400" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op20} 100`" :stroke-dashoffset="`-${metricas.porcentajes.op100 + metricas.porcentajes.op80 + metricas.porcentajes.op60 + metricas.porcentajes.op40}`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />

                <path v-if="metricas.porcentajes.op0 > 0" class="text-red-600" stroke="currentColor" stroke-width="3" fill="transparent" :stroke-dasharray="`${metricas.porcentajes.op0} 100`" :stroke-dashoffset="`-${metricas.porcentajes.op100 + metricas.porcentajes.op80 + metricas.porcentajes.op60 + metricas.porcentajes.op40 + metricas.porcentajes.op20}`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              </svg>

              <div class="absolute inset-0 flex items-center justify-center">
                <span class="font-bold text-gray-900 transition-all duration-300" :class="itemEnSlotPrincipal === 'b' ? 'text-lg' : 'text-xs'">
                  {{ metricas.scoreGlobal }}%
                </span>
              </div>
            </div>

            <div class="grid grid-cols-3 gap-y-1 gap-x-0.5 text-[10px]">
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                <span class="font-medium text-gray-600">100%</span>
              </div>
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-lime-500 rounded-full"></div>
                <span class="font-medium text-gray-600">80%</span>
              </div>
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-yellow-400 rounded-full"></div>
                <span class="font-medium text-gray-600">60%</span>
              </div>
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-orange-400 rounded-full"></div>
                <span class="font-medium text-gray-600">40%</span>
              </div>
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-red-400 rounded-full"></div>
                <span class="font-medium text-gray-600">20%</span>
              </div>
              <div class="flex items-center justify-center gap-1">
                <div class="w-1.5 h-1.5 bg-red-600 rounded-full"></div>
                <span class="font-medium text-gray-600">0%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :data-swapy-slot="!swapyFailed ? 'c' : null">
        <div :data-swapy-item="!swapyFailed ? 'c' : null" @click="abrirModalAqi" class="rounded-xl p-3 sm:p-4 border h-32 sm:h-36 flex flex-col justify-center cursor-pointer transition-colors duration-300" :class="itemEnSlotPrincipal === 'c' ? 'border-blue-400 bg-blue-50/30 shadow-md' : 'border-efintelwhite-55 bg-white hover:shadow-md'">
          <div class="text-center">
            <p class="text-xs font-medium text-gray-600 mb-1 p-1">Clima Ciudad - <span class="text-xs font-medium text-gray-700"> {{ obtenerAqiTexto(metricas.promedioAQI) }}</span></p>

            <div class="flex justify-center mb-2">
              <div class="w-8 h-8 rounded-full flex items-center justify-center" :class="obtenerColorFondoAQI(metricas.promedioAQI)">
                <svg v-if="metricas.promedioAQI <= 50" class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-1.5-1.5L10 14l2 2 4-4 1.5 1.5L10 17zm-3-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                  <circle cx="9" cy="10" r="1" />
                  <circle cx="15" cy="10" r="1" />
                  <path d="M8.5 14.5c.5.5 1.5 1 3.5 1s3-.5 3.5-1" />
                </svg>
                <svg v-else-if="metricas.promedioAQI <= 100" class="w-5 h-5 text-yellow-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
                  <circle cx="9" cy="10" r="1.5" />
                  <circle cx="15" cy="10" r="1.5" />
                  <path d="M8 15h8" stroke="currentColor" stroke-width="1.5" fill="none" />
                </svg>
                <svg v-else-if="metricas.promedioAQI <= 150" class="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
                  <circle cx="9" cy="10" r="1.5" />
                  <circle cx="15" cy="10" r="1.5" />
                  <path d="M8 16c1-.5 2.5-1 4-1s3 .5 4 1" stroke="currentColor" stroke-width="1.5" fill="none" />
                </svg>
                <svg v-else class="w-5 h-5" :class="obtenerColorIconoAQI(metricas.promedioAQI)" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
                  <circle cx="9" cy="10" r="1.5" />
                  <circle cx="15" cy="10" r="1.5" />
                  <path d="M16 16c-1-.5-2.5-1-4-1s-3 .5-4 1" stroke="currentColor" stroke-width="1.5" fill="none" />
                </svg>
              </div>
            </div>
            <div class="flex items-center justify-center gap-2">
              <p class="text-xs font-medium text-gray-500 mb-1">AQI:</p>
              <p class="font-bold transition-all duration-300" :class="[obtenerColorAQI(metricas.promedioAQI), itemEnSlotPrincipal === 'c' ? 'text-3xl sm:text-4xl' : 'text-xl sm:text-2xl']">{{ metricas.promedioAQI }}</p>
              <p class="text-xs font-medium text-gray-500 mb-1">TEMP:</p>
              <span class="text-xl sm:text-2xl font-bold" :class="obtenerColorAQI(metricas.promedioAQI)">{{ metricas.temperaturaCiudad !== null ? metricas.temperaturaCiudad.toFixed(1) : '--' }}°</span>
            </div>
          </div>
        </div>
      </div>

      <div :data-swapy-slot="!swapyFailed ? 'd' : null">
        <div :data-swapy-item="!swapyFailed ? 'd' : null" class="rounded-xl p-3 sm:p-4 border h-32 sm:h-36 flex flex-col justify-between transition-colors duration-300" :class="itemEnSlotPrincipal === 'd' ? 'border-blue-400 bg-blue-50/30 shadow-md' : 'border-efintelwhite-55 bg-white hover:shadow-md'">
          <div class="flex items-center justify-between mb-1">
            <h3 class="text-xs font-medium text-gray-600">Temperatura interior Tienda</h3>
          </div>
          <div class="text-center flex-1 flex flex-col justify-center">
            <div class="relative">
              <span class="font-bold transition-all duration-300" :class="[obtenerColorTemperatura(metricas.temperaturaActual), itemEnSlotPrincipal === 'd' ? 'text-4xl sm:text-5xl' : 'text-2xl sm:text-3xl']">
                {{ metricas.temperaturaActual !== null ? metricas.temperaturaActual.toFixed(1) : '--' }}
              </span>
              <span class="text-sm font-medium text-gray-500 ml-1">°C</span>
            </div>
          </div>
          <div class="flex items-center justify-between pt-2 border-t border-gray-100">
            <div class="text-center flex-1">
              <p class="text-xs font-medium text-gray-500">Máx.</p>
              <p class="text-xs font-bold text-red-500">{{ metricas.temperaturaMaxima !== null ? metricas.temperaturaMaxima.toFixed(1) : '--' }}°C</p>
            </div>
            <div class="w-px h-6 bg-gray-200 mx-2"></div>
            <div class="text-center flex-1">
              <p class="text-xs font-medium text-gray-500">Mín.</p>
              <p class="text-xs font-bold text-blue-500">{{ metricas.temperaturaMinima !== null ? metricas.temperaturaMinima.toFixed(1) : '--' }}°C</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="swapyFailed && debugMode" class="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
      Swapy no se pudo inicializar. Las tarjetas se muestran en modo estático.
    </div>
  </div>
  <ModalAqiInfo :visible="isAqiModalVisible" @close="isAqiModalVisible = false" />
  <ModalOperacionInfo :visible="isOperacionModalVisible" @close="isOperacionModalVisible = false" :localId="localId" @operatividad-actualizada="manejarOperatividadActualizada" />
</template>

<script setup>
import { createSwapy } from 'swapy'
import { onMounted, onUnmounted, ref, reactive, watch, defineProps, defineExpose, defineEmits, computed, nextTick } from 'vue'
import { sessionState } from '@/state/sessionState'
import LocalesService from '@/services/locales/locales.js'

import ModalAqiInfo from '@/components/dispositivos/ModalAqiInfo.vue'
import ModalOperacionInfo from '@/components/dispositivos/ModalOperacionInfo.vue'

const props = defineProps({
  totalDispositivos: { type: Number, default: null },
  totalOnline: { type: Number, default: null },
  totalOffline: { type: Number, default: null },
  totalAlertas: { type: Number, default: null },

  empresaId: { type: [Number, String], default: null },
  localId: { type: [Number, String], default: null },
  autoRefresh: { type: Boolean, default: true },
  refreshInterval: { type: Number, default: 30000 },
  useBackend: { type: Boolean, default: false }
})

const emit = defineEmits(['operatividad-actualizada'])

const abrirModalAqi = () => { isAqiModalVisible.value = true }
const abrirModalOperacion = () => { isOperacionModalVisible.value = true }

const isAqiModalVisible = ref(false)
const isOperacionModalVisible = ref(false)
const swapyContainer = ref()
const swapy = ref(null)
const swapyFailed = ref(false)
const loading = ref(true)
const error = ref(null)
const locales = ref([])
const itemEnSlotPrincipal = ref('a')
let refreshTimer = null
const debugMode = ref(process.env.NODE_ENV === 'development')

// Novedad: El estado incluye scoreGlobal y 6 tramos de porcentajes
const metricas = reactive({
  totalDispositivos: 0,
  operativos: 0,
  fueraServicio: 0,
  alertasActivas: 0,
  scoreGlobal: 0, // Nueva métrica central
  promedioAQI: 0,
  temperaturaActual: null,
  temperaturaMaxima: null,
  temperaturaMinima: null,
  temperaturaCiudad: null,
  porcentajes: {
    op100: 0,
    op80: 0,
    op60: 0,
    op40: 0,
    op20: 0,
    op0: 0
  }
})

const manejarOperatividadActualizada = () => {
  cargarDatos(true);

  emit('operatividad-actualizada');
}

const usandoPropsAntiguas = computed(() => {
  return props.totalDispositivos !== null ||
    props.totalOnline !== null ||
    props.totalOffline !== null ||
    props.totalAlertas !== null
})

const debeUsarBackend = computed(() => {
  return props.useBackend || !usandoPropsAntiguas.value
})

const cargarDatos = async (isSilent = false) => {
  try {
    if (!isSilent) {
      loading.value = true
    }
    error.value = null

    if (usandoPropsAntiguas.value) {
      calcularMetricasDesdeProps()
      return
    }

    if (props.localId) {
      const localEspecifico = await LocalesService.obtenerLocalPorId(props.localId)
      locales.value = [localEspecifico]
    } else if (props.empresaId) {
      locales.value = await LocalesService.obtenerLocalesPorEmpresa(props.empresaId)
    } else {
      locales.value = await LocalesService.obtenerTodosLosLocales()
    }
    calcularMetricasDesdeBackend()

  } catch (err) {
    if (err.codigo === 'SESSION_SOFT_LOCK' || (err.message && err.message.includes('Sesión expirada'))) {
      return
    }
    error.value = err.message || 'Error desconocido cargando métricas'
  } finally {
    if (!isSilent) {
      loading.value = false
    }
  }
}

// Lógica legacy por compatibilidad
const calcularMetricasDesdeProps = () => {
  const totalDisp = props.totalDispositivos || 0
  const online = props.totalOnline || 0
  const offline = props.totalOffline || 0
  const alertas = props.totalAlertas || 0
  const total = totalDisp || 1

  const porcentajes = {
    op100: (online / total) * 100,
    op80: 0, op60: 0, op40: 0, op20: 0,
    op0: (offline / total) * 100
  }

  Object.assign(metricas, {
    totalDispositivos: totalDisp,
    operativos: online,
    fueraServicio: offline,
    alertasActivas: alertas,
    scoreGlobal: Math.round((online / total) * 100),
    promedioAQI: 0,
    porcentajes
  })
}

let calculandoMetricas = false

const calcularMetricasDesdeBackend = () => {
  if (calculandoMetricas) return
  calculandoMetricas = true

  try {
    if (!locales.value.length) {
      Object.assign(metricas, {
        totalDispositivos: 0, operativos: 0, fueraServicio: 0, alertasActivas: 0, scoreGlobal: 0, promedioAQI: 0,
        temperaturaActual: null, temperaturaMaxima: null, temperaturaMinima: null, temperaturaCiudad: null,
        porcentajes: { op100: 0, op80: 0, op60: 0, op40: 0, op20: 0, op0: 0 }
      })
      return
    }

    let totalDispositivos = 0, totalOperativos = 0, totalFueraServicio = 0, totalAlertas = 0, totalAQI = 0, totalTemperaturaCiudad = 0, totalTemperatura = 0
    let localesConAQI = 0, localesConTempCiudad = 0, localesConDispositivos = 0, localesConTemperatura = 0
    let maxTempEncontrada = -999, minTempEncontrada = 999, hayDatosMax = false, hayDatosMin = false

    // Sumar métricas
    locales.value.forEach((local) => {
      totalDispositivos += local.total_dispositivos || 0
      totalOperativos += local.total_dispositivos_operativos || 0
      totalFueraServicio += local.total_dispositivos_fuera_de_servicio || 0
      totalAlertas += local.total_alertas_activas || 0

      if (local.aqi && local.aqi > 0) { totalAQI += local.aqi; localesConAQI++ }
      if (local.temperatura_ciudad !== null && local.temperatura_ciudad !== undefined) { totalTemperaturaCiudad += local.temperatura_ciudad; localesConTempCiudad++ }
      if (local.temperatura_interior !== null && local.temperatura_interior !== undefined) { totalTemperatura += local.temperatura_interior; localesConTemperatura++ }

      if (local.max_temperatura_interior !== null && local.max_temperatura_interior !== undefined) {
        if (local.max_temperatura_interior > maxTempEncontrada) maxTempEncontrada = local.max_temperatura_interior
        hayDatosMax = true
      }
      if (local.min_temperatura_interior !== null && local.min_temperatura_interior !== undefined) {
        if (local.min_temperatura_interior < minTempEncontrada) minTempEncontrada = local.min_temperatura_interior
        hayDatosMin = true
      }
      if ((local.total_dispositivos || 0) > 0) localesConDispositivos++
    })

    let porcentajes = { op100: 0, op80: 0, op60: 0, op40: 0, op20: 0, op0: 0 }
    let scoreCalculado = 0

    if (totalDispositivos > 0 && localesConDispositivos > 0) {
      let tp100 = 0, tp80 = 0, tp60 = 0, tp40 = 0, tp20 = 0, tp0 = 0

      locales.value.forEach(local => {
        const dLoc = local.total_dispositivos || 0
        if (dLoc > 0) {
          tp100 += (local.p_op100 || 0) * dLoc
          tp80 += (local.p_op80 || 0) * dLoc
          tp60 += (local.p_op60 || 0) * dLoc
          tp40 += (local.p_op40 || 0) * dLoc
          tp20 += (local.p_op20 || 0) * dLoc
          tp0 += (local.p_op0 || 0) * dLoc
        }
      })

      // Convertir de vuelta a porcentajes globales (0-100)
      porcentajes = {
        op100: tp100 / totalDispositivos,
        op80: tp80 / totalDispositivos,
        op60: tp60 / totalDispositivos,
        op40: tp40 / totalDispositivos,
        op20: tp20 / totalDispositivos,
        op0: tp0 / totalDispositivos
      }

      // El score global es la suma ponderada del estado real del hardware
      scoreCalculado = Math.round(
        (porcentajes.op100 * 1) +
        (porcentajes.op80 * 0.8) +
        (porcentajes.op60 * 0.6) +
        (porcentajes.op40 * 0.4) +
        (porcentajes.op20 * 0.2)
        // op0 se multiplica por 0, no suma al score.
      )
    }

    const promedioAQI = localesConAQI > 0 ? Math.round(totalAQI / localesConAQI) : 0
    const temperaturaPromedio = localesConTemperatura > 0 ? (totalTemperatura / localesConTemperatura) : null
    const temperaturaMaxFinal = hayDatosMax ? maxTempEncontrada : null
    const temperaturaMinFinal = hayDatosMin ? minTempEncontrada : null
    const promedioTempCiudad = localesConTempCiudad > 0 ? (totalTemperaturaCiudad / localesConTempCiudad) : null

    Object.assign(metricas, {
      totalDispositivos,
      operativos: totalOperativos,
      fueraServicio: totalFueraServicio,
      alertasActivas: totalAlertas,
      scoreGlobal: scoreCalculado,
      promedioAQI,
      temperaturaActual: temperaturaPromedio,
      temperaturaMaxima: temperaturaMaxFinal,
      temperaturaMinima: temperaturaMinFinal,
      temperaturaCiudad: promedioTempCiudad,
      porcentajes
    })

  } finally {
    calculandoMetricas = false
  }
}

// Helpers de UI
const obtenerAqiTexto = (aqi) => {
  if (aqi <= 50) return 'Bueno'
  if (aqi <= 100) return 'Moderado'
  if (aqi <= 150) return 'No saludable para grupos sensibles'
  if (aqi <= 200) return 'Insalubre'
  if (aqi <= 300) return 'Muy insalubre'
  return 'Peligroso'
}

const obtenerColorAQI = (aqi) => {
  if (aqi <= 50) return 'text-green-500'
  if (aqi <= 100) return 'text-yellow-400'
  if (aqi <= 150) return 'text-orange-500'
  if (aqi <= 200) return 'text-red-500'
  if (aqi <= 300) return 'text-purple-600'
  return 'text-red-900'
}

const obtenerColorFondoAQI = (aqi) => {
  if (aqi <= 50) return 'bg-green-500'
  if (aqi <= 100) return 'bg-yellow-400'
  if (aqi <= 150) return 'bg-orange-500'
  if (aqi <= 200) return 'bg-red-500'
  if (aqi <= 300) return 'bg-purple-600'
  return 'bg-red-900'
}

const obtenerColorIconoAQI = (aqi) => {
  if (aqi <= 50) return 'text-green-600'
  if (aqi <= 100) return 'text-yellow-600'
  if (aqi <= 150) return 'text-orange-600'
  if (aqi <= 200) return 'text-red-600'
  if (aqi <= 300) return 'text-purple-600'
  return 'text-red-800'
}

const obtenerColorTemperatura = (temp) => {
  if (!temp) return 'text-blue-600'
  if (temp < 18) return 'text-blue-600'
  if (temp < 22) return 'text-cyan-600'
  if (temp < 25) return 'text-green-600'
  if (temp < 28) return 'text-yellow-600'
  if (temp < 32) return 'text-orange-600'
  return 'text-red-600'
}

onMounted(async () => {
  await cargarDatos()
  const initSwapy = () => {
    nextTick(() => {
      try {
        if (swapyContainer.value) {
          swapy.value = createSwapy(swapyContainer.value, { animation: 'dynamic' })
          swapy.value.onSwap(event => {
            setTimeout(() => { itemEnSlotPrincipal.value = event.newSlotItemMap.asObject.a }, 250)
          })
          swapyFailed.value = false
        } else {
          swapyFailed.value = true
        }
      } catch (error) {
        swapyFailed.value = true
      }
    })
  }
  initSwapy()
  if (debeUsarBackend.value && props.autoRefresh) {
    refreshTimer = setInterval(() => cargarDatos(true), props.refreshInterval)
  }
})

onUnmounted(() => {
  if (swapy.value) swapy.value.destroy()
  if (refreshTimer) clearInterval(refreshTimer)
})

watch(() => props.empresaId, () => { if (debeUsarBackend.value) cargarDatos() }, { immediate: false })
watch(() => props.localId, () => { if (debeUsarBackend.value) cargarDatos() }, { immediate: false })
watch(() => sessionState.isSoftLocked, (estaBloqueado) => { if (!estaBloqueado && debeUsarBackend.value) cargarDatos() })

watch([
  () => props.totalDispositivos,
  () => props.totalOnline,
  () => props.totalOffline,
  () => props.totalAlertas
], () => {
  if (usandoPropsAntiguas.value) calcularMetricasDesdeProps()
}, { immediate: false })

defineExpose({ cargarDatos, metricas })
</script>

<style scoped>
/* Agregamos las nuevas transiciones de los colores añadidos (lime, orange) */
.text-green-500 path,
.text-lime-500 path,
.text-yellow-400 path,
.text-orange-400 path,
.text-red-400 path,
.text-red-600 path {
  transition: stroke-dasharray 0.5s ease-in-out, stroke-dashoffset 0.5s ease-in-out;
}

[data-swapy-item]:hover:not([data-swapy-dragging]) {
  transform: translateY(-1px);
  transition: transform 0.15s ease-out;
}
</style>